import React from "react";
import Icon from "./Icon";
import KebabMenu from "../../../components/KebabMenu";

/**
 * One test as a row: status tile, title and settings, availability, submissions and actions. `menuItems` are the
 * overflow actions ({ icon, label, danger, onSelect }). Publishing and results are shown as buttons when allowed.
 */
export default function TestRow({
  model, canEdit, onTogglePublish, onResults, onAnswerKey, menuItems, reorder, dragProps, dragging, dropOver,
}) {
  const { status } = model;
  const cls = ["test", dragging ? "dragging" : "", dropOver ? "ins-b" : ""].filter(Boolean).join(" ");
  return (
    <div className={cls} data-testid={`test-row-${model.id}`} {...dragProps}>
      <span className={`tile ts-${status}`} aria-hidden="true">
        <Icon n={status === "locked" ? "lock" : "test"} s={17} />
      </span>

      <div className="main">
        <h3>
          <span title={model.title}>{model.title}</span>
          <em className={`pill ${status}`}>{model.statusLabel}</em>
          {model.inLearningPlan && <em className="pill locked">In Learning Plan</em>}
        </h3>
        {model.description && <p className="desc">{model.description}</p>}
        <div className="meta"><span className="mu">{model.summary}</span></div>
      </div>

      <div className="kv avail">
        <div className={model.visible ? "v-on" : "v-off"}>
          {model.visible ? <><Icon n="eye" /><span>Visible to students</span></> : <><Icon n="eyeOff" /><b>Hidden from students</b></>}
        </div>
        {model.window ? <div><Icon n="cal" /><span>{model.window}</span></div> : <div className="mu"><Icon n="cal" />No availability window</div>}
      </div>

      <div className="kv subs">
        <div><b>{model.submitted}</b>&nbsp;of {model.totalStudents} submitted</div>
        <div className="mu">{model.note}</div>
      </div>

      <div className="acts">
        {reorder && (
          <span className="reorder">
            <button type="button" aria-label={`Move ${model.title} up`} disabled={reorder.upDisabled} onClick={reorder.onUp}><Icon n="up" s={13} /></button>
            <button type="button" aria-label={`Move ${model.title} down`} disabled={reorder.downDisabled} onClick={reorder.onDown}><Icon n="down" s={13} /></button>
          </span>
        )}
        {canEdit && (model.visible ? (
          <button type="button" className="btn btn-o btn-sm" onClick={onTogglePublish}><Icon n="eyeOff" />Turn off</button>
        ) : (
          <button type="button" className="btn btn-p btn-sm" onClick={onTogglePublish}><Icon n="eye" />Publish</button>
        ))}
        {model.submitted > 0 ? (
          <button type="button" className="btn btn-o btn-sm" onClick={onResults}><Icon n="chart" />Results</button>
        ) : (
          <button type="button" className="btn btn-o btn-sm" onClick={onAnswerKey}><Icon n="key" />Answer key</button>
        )}
        <KebabMenu label={`More actions for ${model.title}`} triggerIcon={<Icon n="more" s={16} />} items={menuItems} />
      </div>
    </div>
  );
}
